function getLanguageTo(contentFulNodes) {
  // Assume we are using allContentfulXXX with nodes > seo > slug
  // slug + node_locale
  return (
    contentFulNodes &&
    Object.fromEntries(
      contentFulNodes?.map(node => [node.node_locale, `/${node.seo.slug}`])
    )
  );
}

export default { getLanguageTo };
